import React from 'react';
import { Box, Button, Modal, Typography, useTheme, IconButton } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';

import Login from '../auth/modal/LoginModal';
import Register from '../auth/modal/RegisterModal';

export const buttonStyleSx = {
    marginLeft: 1,
    marginRight: 0,
    height: 30,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
};

const AuthButtons = ({ loadUser }) => {
    const [openLogin, setOpenLogin] = React.useState(false);
    const [openRegister, setOpenRegister] = React.useState(false);

    const theme = useTheme();

    const handleOpenLogin = () => setOpenLogin(true);
    const handleOpenRegister = () => setOpenRegister(true);

    const handleClose = () => {
        setOpenLogin(false);
        setOpenRegister(false);
    };

    const handleLoadUser = () => {
        loadUser();
        handleClose();
    };

    const handleSwitchToLogin = () => {
        setOpenRegister(false);
        setOpenLogin(true);
    };

    const handleSwitchToRegister = () => {
        setOpenRegister(true);
        setOpenLogin(false);
    };

    return (
        <Box sx={{ p: 0, m: 0, display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
            <Button onClick={handleOpenRegister} variant="contained" sx={{ ...buttonStyleSx }}>
                <Typography variant="subtitle1">SELL YOUR CONTENT</Typography>
            </Button>
    
            <IconButton onClick={handleOpenLogin}>
                <PersonOutlineOutlinedIcon sx={{ color: theme.palette.text.primary }} />
            </IconButton>

            <Modal open={openLogin} onClose={handleClose} aria-labelledby="modal-auth-login">
                <Box sx={{ m: 0, p: 0 }}>
                    <Login
                        handleClose={handleClose}
                        handleOpenRegister={handleSwitchToRegister}
                        handleLoadUser={handleLoadUser}
                    />
                </Box>
            </Modal>

            <Modal open={openRegister} onClose={handleClose} aria-labelledby="modal-auth-register">
                <Box sx={{ m: 0, p: 0 }}>
                    <Register handleClose={handleClose} handleOpenLogin={handleSwitchToLogin} />
                </Box>
            </Modal>
        </Box>
    );
};

export default AuthButtons;
